/**
 * Current App
 */

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import CurrentAppButton from './CurrentAppButton';
import recekWordmark from '../../../assets/recek-wordmark.png';
import css from './CurrentApp.css';

export const PLATFORM_LOGO_ALT = 'ReČeK – registr českých knih';

const propTypes = {
  config: PropTypes.shape({
    platformName: PropTypes.string,
    platformDescription: PropTypes.string,
  }),
  currentApp: PropTypes.shape(
    {
      displayName: PropTypes.string,
      home: PropTypes.string,
      iconData: PropTypes.object, // Only used by "Settings" since it's not a standalone app yet
      module: PropTypes.string,
      name: PropTypes.string,
      route: PropTypes.string,
    },
  ),
  id: PropTypes.string,
  intl: PropTypes.object,
  badge: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

const CurrentApp = ({ config, currentApp, id, intl, badge }) => {
  // Platform home (no app selected): the ReČeK wordmark stands in for both the
  // FOLIO home icon and the platform name label.
  if (!currentApp) {
    const platformName = config.platformName || 'ReČeK';

    return (
      <CurrentAppButton
        data-test-current-app-home-button
        ariaLabel={platformName}
        badge={badge}
        icon={<img src={recekWordmark} alt={PLATFORM_LOGO_ALT} className={css.platformLogo} />}
        id={id}
      />
    );
  }

  const { displayName, iconData, module, home, route } = currentApp;
  const href = home || route;
  const ariaLabel = href ? intl.formatMessage({ id: 'stripes-core.mainnav.currentAppAriaLabel' }, { appName: displayName }) : displayName;

  return (
    <CurrentAppButton
      data-test-current-app-home-button
      ariaLabel={ariaLabel}
      badge={badge}
      iconData={iconData}
      iconKey={module}
      id={id}
      label={displayName}
      to={href}
    />
  );
};

CurrentApp.propTypes = propTypes;

export default injectIntl(CurrentApp);
